import validate from "/Users/laurentlang/Documents/Websites/Online/Patchbox/pb-rack-planner-v3/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/Users/laurentlang/Documents/Websites/Online/Patchbox/pb-rack-planner-v3/frontend/middleware/auth.global.ts";
import manifest_45route_45rule from "/Users/laurentlang/Documents/Websites/Online/Patchbox/pb-rack-planner-v3/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  protected: () => import("/Users/laurentlang/Documents/Websites/Online/Patchbox/pb-rack-planner-v3/frontend/middleware/protected.ts")
}